import { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router';
import { api, Spinner } from '@karozik/ui';

export function Login() {
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();
  const [params] = useSearchParams();

  return (
    <main className="mx-auto flex min-h-dvh max-w-sm flex-col justify-center px-6">
      <img src="/icon.svg" alt="" className="mb-6 h-16 w-16" />
      <h1 className="font-display text-3xl font-bold">
        <span className="text-gradient">KaroZik</span> · Régie
      </h1>
      <form
        className="mt-8 flex flex-col gap-4"
        onSubmit={async (e) => {
          e.preventDefault();
          setBusy(true);
          try {
            await api('/api/admin/login', { method: 'POST', json: { password } });
            const next = params.get('next');
            navigate(next?.startsWith('/') ? next : '/', { replace: true });
          } catch (err) {
            setError((err as Error).message);
          } finally {
            setBusy(false);
          }
        }}
      >
        <input
          type="password"
          autoFocus
          autoComplete="current-password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Mot de passe"
          className="rounded-2xl border border-line bg-surface px-4 py-4 text-lg outline-none focus:border-pink"
        />
        {error && <p className="text-sm text-danger">{error}</p>}
        <button disabled={!password || busy} className="bg-gradient-neon flex justify-center rounded-2xl py-4 font-bold disabled:opacity-40">
          {busy ? <Spinner /> : 'Entrer'}
        </button>
      </form>
    </main>
  );
}
